import React, { useMemo } from 'react'
import { Tag as AntTag, TagProps, Typography } from 'antd'
import { colorTextSubtle, error, info, success, warning } from 'src/app/themes/primaryThemeDefault'

const CommonTag: React.FC<
  TagProps & {
    displayLeftDot?: boolean
  }
> = (props) => {
  const { style, color, children, displayLeftDot, ...etc } = props

  const textColor = useMemo(() => {
    switch (color) {
      case 'success':
        return success
      case 'error':
        return error
      case 'warning':
        return warning
      case 'processing':
        return info
      case 'default':
      default:
        return colorTextSubtle
    }
  }, [color])

  return (
    <AntTag
      color={color}
      style={{
        border: 0,
        display: 'flex',
        flexDirection: 'row',
        gap: 4,
        alignItems: 'center',
        justifyContent: 'center',
        width: 56,
        ...style,
      }}
    >
      {displayLeftDot && (
        <div
          style={{
            width: 4,
            height: 4,
            backgroundColor: textColor,
            borderRadius: 10000,
          }}
        />
      )}
      <Typography.Text
        style={{
          color: textColor,
          fontFamily: 'MyriadPro',
          fontSize: 14,
        }}
      >
        {children}
      </Typography.Text>
    </AntTag>
  )
}

export default CommonTag
